import React, { useEffect, useMemo } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useDispatch, useSelector } from 'react-redux';
import { getI18n } from 'react-i18next';
import {
  getRecaptcha,
  disableRecaptcha,
  resetCaptcha,
} from '../../store/modules/recaptcha/actions';
import { Container } from './styles';

const SITE_KEY_RECAPCTHA =
  process.env.REACT_APP_ENV?.toLowerCase() === 'dev' ||
  process.env.REACT_APP_ENV?.toLowerCase() === 'test'
    ? '6Lf2f7YqAAAAAMslMGjwIrCS7CqlPCRYzejjLufh'
    : '6LdUGqAaAAAAANhwx9wrLgp3JhNsDusTHj4f4DH6';

const ReCaptchaGoogle = () => {
  const component = React.createRef();
  const languageApp = getI18n().language;

  const changeLanguage = useMemo(() => getI18n().language, [languageApp]);

  const recaptcha = useSelector((state) => state.recaptcha);

  const dispatch = useDispatch();

  const handleCaPtcha = (value) => {
    dispatch(getRecaptcha(value));
  };

  const handleDisable = (value) => {
    dispatch(disableRecaptcha(value));
  };

  useEffect(() => {
    if (recaptcha?.resetRef) {
      component.current.reset();
      dispatch(getRecaptcha(null));
      dispatch(disableRecaptcha(true));
      dispatch(resetCaptcha(false));
    }
  });

  useEffect(() => {
    dispatch(disableRecaptcha(true));
    dispatch(resetCaptcha(true));
  }, [changeLanguage]);

  return (
    <Container>
      <ReCAPTCHA
        hl={changeLanguage}
        ref={component}
        sitekey={SITE_KEY_RECAPCTHA}
        onChange={(value) => {
          handleCaPtcha(value);
          handleDisable(false);
        }}
        onExpired={() => {
          handleCaPtcha(null);
          handleDisable(true);
        }}
      />
    </Container>
  );
};

export default ReCaptchaGoogle;
